import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material';
import '@mui/material/styles';
import keygen from 'uuid/v4';
import { Button } from '../../components/Button/Button.js';
import { IconButton } from '../../components/IconButton/IconButton.js';
import { Tooltip } from '../../components/Tooltip/Tooltip.js';
import { buttonTypes } from './button.types.js';
var _excluded = ["type", "translate", "isIconButton", "showIcon", "showText", "tooltipTitle", "actionType", "size", "toolTipPosition", "classes", "text"],
    _excluded2 = ["id"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var createButtonProps = function createButtonProps(type, showIcon, translate) {
  var buttonType = buttonTypes[type];
  var baseTypeConfig = {
    text: translate(buttonType.text),
    label: translate(buttonType.text)
  };

  if ('isActionIcon' in buttonType || 'isExpansionPanelIcon' in buttonType) {
    return _objectSpread(_objectSpread({}, baseTypeConfig), {}, {
      actionIconType: type,
      isExpansionPanelIconType: type,
      icon: showIcon ? buttonType.icon : undefined
    });
  }

  return _objectSpread(_objectSpread({}, baseTypeConfig), {}, {
    icon: showIcon ? buttonType.icon : undefined
  });
};

var createButton = function createButton(_ref) {
  var type = _ref.type,
      translate = _ref.translate,
      isIconButton = _ref.isIconButton,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? !!isIconButton : _ref$showIcon,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? true : _ref$showText,
      tooltipTitle = _ref.tooltipTitle,
      _ref$actionType = _ref.actionType,
      actionType = _ref$actionType === void 0 ? 'secondary' : _ref$actionType,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      toolTipPosition = _ref.toolTipPosition,
      classes = _ref.classes,
      text = _ref.text,
      rest = _objectWithoutProperties(_ref, _excluded);

  var props = _objectSpread(_objectSpread({}, createButtonProps(type, showIcon, translate)), {}, {
    color: actionType,
    size: size
  }, rest);

  var id = props.id,
      restProps = _objectWithoutProperties(props, _excluded2);
  /* istanbul ignore next */


  if (process.env.NODE_ENV !== 'production') {
    checkInvalidButtonId(id);
  }

  var key = id !== null && id !== void 0 ? id : keygen();
  var button = /*#__PURE__*/React.createElement(Button, _extends({
    key: key,
    className: classes,
    id: id ? String(id) : undefined
  }, restProps), showText ? text || restProps.text : '');
  var iconButton = /*#__PURE__*/React.createElement(IconButton, _extends({
    key: key,
    className: classes,
    id: id ? String(id) : undefined,
    fontSize: size,
    component: "span"
  }, restProps)); // Pick the component

  var component = isIconButton ? iconButton : button;
  return tooltipTitle || isIconButton ? /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltipTitle || text || restProps.text,
    placement: toolTipPosition,
    key: key
  }, component) : component;
};
/* Utilities */


var hasCheckInvalidButtonIdRun = false;
/* istanbul ignore next */

function checkInvalidButtonId(id) {
  if (id === undefined && !hasCheckInvalidButtonIdRun) {
    console.warn("Please make sure to pass an id to button factory, otherwise the button will unmount / remount on every re-render instead of updating in place.");
    hasCheckInvalidButtonIdRun = true;
  }
}

export { createButton };